import { captureDeeplinkPromoCode } from "@utils";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./components/App";

import "./index.css";

// Before React mounts and the router can navigate off the landing URL, since that URL is the only
// place a promo code from a printed OneLink or a marketing link ever appears.
captureDeeplinkPromoCode();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
